

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  tooltipWrapper: {
    position: 'relative',
    display: 'inline-block'
  },
  tooltip: {
    position: 'absolute',
    zIndex: 2,
    color: colors.neutral.white,
    backgroundColor: colors.neutral[600],
    borderRadius: '0.4rem',
    font: {
      size: '1.4rem',
      lineHeight: '2.2rem',
      weight: 700
    },
    letterSpacing: '0.02rem',
    padding: '0.4rem 1.2rem',
    whiteSpace: 'nowrap',

    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '0rem',
      height: '0rem',
      borderLeft: "0.5rem solid transparent",
      borderRight: "0.5rem solid transparent",
      borderBottom: "0.5rem solid ".concat(colors.neutral[600])
    }
  },
  topStart: {
    bottom: '120%',
    '&::before': {
      transform: 'rotate(180deg)',
      bottom: '-0.5rem',
      left: '10%'
    }
  },
  topCenter: {
    bottom: '120%',
    left: '50%',
    transform: 'translate(-50%, 0)',
    '&::before': {
      transform: 'rotate(180deg)',
      bottom: '-0.5rem',
      left: 'calc(50% - 0.5rem)'
    }
  },
  topEnd: {
    bottom: '120%',
    right: '0rem',
    '&::before': {
      transform: 'rotate(180deg)',
      bottom: '-0.5rem',
      right: '10%'
    }
  },
  bottomStart: {
    top: '120%',
    '&::before': {
      top: '-0.5rem',
      left: '10%'
    }
  },
  bottomCenter: {
    top: '120%',
    left: '50%',
    transform: 'translate(-50%, 0)',
    '&::before': {
      top: '-0.5rem',
      left: 'calc(50% - 0.5rem)'
    }
  },
  bottomEnd: {
    top: '120%',
    right: '0rem',
    '&::before': {
      top: '-0.5rem',
      right: '10%'
    }
  },
  rightStart: {
    top: '0rem',
    left: '110%',
    '&::before': {
      transform: 'rotate(-90deg)',
      top: '25%',
      left: '-0.7rem'
    }
  },
  rightCenter: {
    top: '50%',
    transform: 'translate(0, -50%)',
    left: '110%',
    '&::before': {
      transform: 'rotate(-90deg)',
      top: 'calc(50% - 0.25rem)',
      left: '-0.7rem'
    }
  },
  rightEnd: {
    bottom: '0rem',
    left: '110%',
    '&::before': {
      transform: 'rotate(-90deg)',
      bottom: '25%',
      left: '-0.7rem'
    }
  },
  leftStart: {
    top: '0rem',
    right: '110%',
    '&::before': {
      transform: 'rotate(90deg)',
      top: '25%',
      right: '-0.7rem'
    }
  },
  leftCenter: {
    top: '50%',
    transform: 'translate(0, -50%)',
    right: '110%',
    '&::before': {
      transform: 'rotate(90deg)',
      top: 'calc(50% - 0.25rem)',
      right: '-0.7rem'
    }
  },
  leftEnd: {
    bottom: '0rem',
    right: '110%',
    '&::before': {
      transform: 'rotate(90deg)',
      bottom: '25%',
      right: '-0.7rem'
    }
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map